var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"app-shape"},[_c('polygon',{attrs:{"points":_vm.points}})])}
var staticRenderFns = []

export { render, staticRenderFns }